import React from "react";
import AppLink from "@/components/new-resolver/app.ink";
import css from "@/components/new-resolver/.module.scss";
import { usePath } from "@/contexts/path/path";
import {
  getDeveloperUrl,
  getProjectURL,
  getUnitUrl,
} from "@/containers/project-screen/ProjectCard";

export default function RedBreadcrumb() {
  const {
    basePath = "/المشاريع-العقارية",
    homeLabel = "المشاريع العقارية",
    developer,
    project,
    unit,
    activeCity,
    updateContext,
  } = usePath();
  return (
    <ul className={`${css.breadcrumb} ${css.red}`}>
      {(activeCity || project || developer) && (
        <>
          <li>
            <AppLink
              path={basePath || "المشاريع-العقارية"}
              onClick={() =>
                updateContext({
                  project: null,
                  developer: null,
                  unit: null,
                  activeCity: null,
                })
              }
            >
              {homeLabel}
            </AppLink>
          </li>
          {activeCity && (
            <li>
              <AppLink navigate path={`${basePath || "/"}${activeCity.path}`}>
                {activeCity.name}
              </AppLink>
            </li>
          )}
          {developer && (
            <li>
              <AppLink
                path={getDeveloperUrl(developer)}
                onClick={() =>
                  updateContext({
                    project: null,
                    unit: null,
                    activeCity: null,
                  })
                }
              >
                {developer?.name}
              </AppLink>
            </li>
          )}
          {project && (
            <li>
              <AppLink
                path={getProjectURL(project)}
                onClick={() =>
                  updateContext({
                    unit: null,
                  })
                }
              >
                {project?.title}
              </AppLink>
            </li>
          )}
          {unit && (
            <li>
              <AppLink
                path={getUnitUrl({
                  ...project,
                  unitCode: unit?.unit_code,
                  unitId: unit?.id,
                })}
              >
                {unit?.unit_code || unit?.id}
              </AppLink>
            </li>
          )}
        </>
      )}
    </ul>
  );
}
